import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, UncontrolledTooltip } from "reactstrap";

import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

import styles from "./IconButton.module.css";

interface IProps {
    openMessagesModal: () => void;
}

export default function IconButton({ openMessagesModal }: IProps) {
    return (
        <>
            <Button
                id="statusMessages"
                className="invisibleButton"
                onClick={openMessagesModal}
                aria-label="View unread system status messages"
            >
                <FontAwesomeIcon
                    className={styles.icon}
                    icon={faTriangleExclamation}
                />
            </Button>
            <UncontrolledTooltip target="statusMessages" placement="bottom">
                Unread system status messages. Messages are always available in
                the help dropdown.
            </UncontrolledTooltip>
        </>
    );
}
